import React, { useEffect } from 'react';
import styles from './ConfirmDialog.module.css';
import Ico from '../common/Ico';

const ICO_ALERT = 'M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01';

const WARN_ICON_STYLE = {
  background: 'var(--warning-50)',
  border: '1px solid var(--warning-200)',
  color: 'var(--warning-600)',
};

export default function ConfirmDialog({
  open,
  title,
  message,
  icon,
  iconStyle,
  children,
  confirmLabel = 'Confirm',
  confirming = false,
  confirmingLabel = 'Processing…',
  confirmDisabled = false,
  danger = false,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape' && !confirming) onCancel(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onCancel, confirming]);

  if (!open) return null;

  return (
    <div
      className={styles.overlay}
      role="presentation"
      onClick={(e) => { if (e.target === e.currentTarget && !confirming) onCancel(); }}
    >
      <div className={styles.modal} role="dialog" aria-modal="true">
        <div className={styles.header}>
          <div className={styles.iconWrap} style={iconStyle || WARN_ICON_STYLE}>
            <Ico d={icon || ICO_ALERT} size={17} />
          </div>
          <div className={styles.headerText}>
            <div className={styles.title}>{title}</div>
            {message && <div className={styles.subtitle}>{message}</div>}
          </div>
        </div>
        {children && <div className={styles.body}>{children}</div>}
        <div className={styles.footer}>
          <button
            className={styles.cancelBtn}
            onClick={onCancel}
            disabled={confirming}
            type="button"
          >
            Cancel
          </button>
          <button
            className={`${styles.confirmBtn}${danger ? ` ${styles.confirmBtnDanger}` : ''}`}
            onClick={onConfirm}
            disabled={confirming || confirmDisabled}
            type="button"
          >
            {confirming ? confirmingLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
